import { useState, useMemo } from "react";
import type { ComboboxOption } from "ui";

export function useDeclineTypeFilter() {
  const [selectedType, setSelectedType] = useState<ComboboxOption<string>>([
    "ALL_TYPES",
    "All types",
  ]);

  const typeOptions: ComboboxOption<string>[] = useMemo(
    () => [
      ["ALL_TYPES", "All types"],
      ["SOFT_DECLINE", "Soft decline"],
      ["HARD_DECLINE", "Hard decline"],
    ],
    []
  );

  return {
    selectedType,
    setSelectedType,
    typeOptions,
  };
}
